import type { UIViewInjectedProps } from '@uirouter/react';

import { Attachments } from '@/components/attachments';
import { AttachmentType } from '@/types/enums';

export const CVExecutionAttachments = ({ transition }: UIViewInjectedProps) => {
  const params = {
    transition,
    apiEntity: 'CVExecution',
    paramId: 'cvExecutionId',
    attachmentType: AttachmentType.CVExecution,
    closeRoute: 'base-layout.cv-executions',
  };

  return <Attachments<cyrian.api.cvExecutions.CVExecutionWithAttachment> {...params} />;
};
